export const formatPrice = (priceInCents) => {
  if (!priceInCents || priceInCents === 0) return '';
  return `${(priceInCents).toFixed(0)} zł`;
};

export const hasSplitPayment = (lessonData) => {
  return lessonData?.online_payment_amount != null && lessonData?.on_site_payment_amount != null;
};

export const formatSplitPaymentInfo = (online, onsite) => {
  if (!online || !onsite) return '';
  const total = online + onsite;
  return {
    online: `${online} zł`,
    onsite: `${onsite} zł`,
    total: `${total} zł`
  };
};

export const formatDateLine = (lessonStart, lessonWeekDay, MONTHS_PL) => {
  if (!lessonStart) return "";
  return `${lessonStart.day} ${MONTHS_PL[lessonStart.month]} (${lessonWeekDay})`;
};

export const formatPassExpiry = (validUntil) => {
  const d = new Date(validUntil);
  return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getFullYear()).slice(-2)}`;
};
